export default function Unauthorized() {
    return (
        <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
            <h1>Unauthorized</h1>
            <h4>You are not authorized to access this application. Please contact your administrator to request access.</h4>
        </div>
    )
}